import axios from "axios";
import apiService from "./apiService";

const baseUrl = process.env.REACT_APP_API_URL;

export default {
  getMachines: async (page, criteria = null) =>
    apiService.get(`machines?page=${page}`, criteria),

  getMachine: async id => apiService.get("machines/".concat(id)),

  createMachine: async data => {
    const machineName = data.get("machineName");
    return apiService.post(
      "machines",
      data,
      `Uploading machine '${machineName}'.`,
      `Machine '${machineName}' created.`
    );
  },

  updateMachine: async (id, data) => {
    const machineName = data.get("machineName");
    return apiService.put(
      "machines/".concat(id),
      data,
      `Uploading machine '${machineName}'.`,
      `Machine '${machineName}' updated.`
    );
  },

  deleteMachine: async id =>
    apiService.del("machines/".concat(id), "Machine deleted")
};



// WEBPACK FOOTER //
// ./src/services/api/machineService.js